var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 18.3333H18.3327",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5918 18.3333V10.8333C2.5918 9.45001 3.83346 8.33334 5.3668 8.33334H14.6251C16.1585 8.33334 17.4001 9.45001 17.4001 10.8333V18.3333",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63281 8.33332V5.97499C4.63281 4.97499 5.53281 4.16666 6.64948 4.16666H13.3578C14.4661 4.16666 15.3661 4.97499 15.3661 5.97499V8.33332",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 11.65L3.24974 11.6583C3.86641 11.6667 4.35807 12.1667 4.35807 12.7833V13.0583C4.35807 13.675 4.85807 14.1833 5.48307 14.1833C6.09974 14.1833 6.60807 13.6833 6.60807 13.0583V12.8C6.60807 12.1833 7.10807 11.675 7.73307 11.675C8.34974 11.675 8.85807 12.175 8.85807 12.8V13.0583C8.85807 13.675 9.35807 14.1833 9.98307 14.1833C10.5997 14.1833 11.1081 13.6833 11.1081 13.0583V12.8C11.1081 12.1833 11.6081 11.675 12.2331 11.675C12.8497 11.675 13.3581 12.175 13.3581 12.8V13.0583C13.3581 13.675 13.8581 14.1833 14.4831 14.1833C15.0997 14.1833 15.6081 13.6833 15.6081 13.0583V12.8C15.6081 12.1833 16.1081 11.675 16.7331 11.675H17.1081",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 4.16667V2.5",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 4.16667V2.5",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.16666V1.66666",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.a7d69de4339f9e479de0d4a427b3b58e.svg";
export { ForwardRef as ReactComponent };